
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 6.5H4a1 1 0 00-1 1v15a1 1 0 001 1h16a1 1 0 001-1v-15a1 1 0 00-1-1zm-15-4l2-2 2 2m-2-2v4m8-2l2 2 2-2m-2 2v-4","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8.502 12.5a2 2 0 100-4 2 2 0 000 4zm2.498 3a2.5 2.5 0 00-4.268-1.768A2.5 2.5 0 006 15.5v2h1l.5 4h2l.5-4h1v-2zm4.502-3a2 2 0 100-4 2 2 0 000 4zm2.498 3a2.5 2.5 0 00-.732-1.768 2.5 2.5 0 00-3.536 0A2.5 2.5 0 0013 15.5v2h1l.5 4h2l.5-4h1v-2z","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    